import UserIcon from '@service-victoria/component-library/components/Icons/User';
import Body from '@service-victoria/component-library/components/Text/Body';
import TextHeading from '@service-victoria/component-library/components/Text/Heading';
import colors from '@service-victoria/component-library/utils/colors';
import styled from 'styled-components';

export const activeColor = colors.brown;
export const primaryColor = colors.orange;

export const Container = styled.div`
  display: flex;
  align-items: center;
  margin-left: 8px;
`;

export const Icon = styled(UserIcon)<{ isActive?: boolean }>`
  flex: 0 0 auto;
  height: 16px;
  margin-right: 24px;
`;

export const Details = styled.div`
  flex: 1 1 auto;
`;

export const Heading = styled(TextHeading.H3).attrs({ as: 'span' })<{ isActive?: boolean }>`
  display: block;
  font-weight: 600;
  color: ${({ isActive }) => (isActive ? activeColor : undefined)};
`;
export const BodyText = styled(Body).attrs({ as: 'span' })<{ isActive?: boolean }>`
  color: ${({ isActive }) => (isActive ? activeColor : undefined)};
`;
